import { defineStore } from 'pinia'
import axios from 'axios'
import { getResponse, getError, getMeta } from '@/composables/api'
import router from '@/router'
import { useGinnelStore } from '@/stores/ginnels/ginnel'

export const useSearchStore = defineStore({
   id: 'search',
   state: () => ({
      results: [],

      storeGinnel: useGinnelStore()
   }),
   actions: {
      search(query) {
			axios.get('search', { params: { query: query }}).then(response => {
            this.results = getResponse(response)
			})
      },
      toFileFromSearch(file_id) {
         this.storeGinnel.gotoFile = file_id
      }
   }
})